import { useRecoilValue } from 'recoil';
import { useHippoText } from './useHippoText';
import { infoModalVariantOpcAtom } from '../recoil/atoms/infoModalVariantOpcAtom';
import type { ViewInformationModalProps } from '../config/modalConfig';
import type { InformationModalVariant } from '../recoil/types/opcTypes';

const useOPCInfoModal = (): { infoProps?: ViewInformationModalProps } => {
    const getHippoText = useHippoText();
    const informationModalVariant = useRecoilValue(infoModalVariantOpcAtom);
    if (!informationModalVariant) {
        return { infoProps: undefined };
    }
    const defaultProps: ViewInformationModalProps = {
        title: '',
        description: '',
        rawHtmlDescription: ''
    };

    const modalPropsMap: Record<
        Exclude<InformationModalVariant, undefined>,
        ViewInformationModalProps
    > = {
        default: defaultProps,
        adultAccFulltimeLeisure: {
            ...defaultProps,
            title: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-FULLTIMEORLEISURE-TITLE'),
            rawHtmlDescription: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-FULLTIMEORLEISURE')
        },
        adultAccContractType: {
            ...defaultProps,
            title: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-CONTRACTTYPE-TITLE'),
            rawHtmlDescription: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-CONTRACTTYPE')
        },
        adultAccInjuryDegreeFivePercent: {
            ...defaultProps,
            title: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-MENGRAD-TITLE'),
            rawHtmlDescription: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-MENGRAD-FIVE-PERCENT')
        },
        adultAccInjuryDegreeEightPercent: {
            ...defaultProps,
            title: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-MENGRAD-TITLE'),
            rawHtmlDescription: getHippoText('DSS-ACC-HIGHLIGHTED-TEXT-MODAL-MENGRAD-EIGHT-PERCENT')
        },
        traNumberInHousehold: {
            ...defaultProps,
            title: getHippoText('DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-HEADER'),
            rawHtmlDescription: getHippoText('DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-DESCRIPTION')
        },
        accReduceInsuranceSum: {
            ...defaultProps,
            // Todo: Use hippo label when label id is define in document [Hippo ACC]
            title: 'Nedsæt forsikringssum',
            description:
                'Før du kan nedsætte din forsikringssum, har vi brug for at tale med dig og rådgive dig omkring konsekvenserne.'
        },
        choInsurancePeriod: defaultProps
    };

    return {
        infoProps: modalPropsMap[informationModalVariant]
    };
};

export { useOPCInfoModal };
